// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"9a20aa06e4d749eecc3d","293":"222f7bad56c9005bfa4a","518":"4218c2fbcbd20e2295e4","779":"99729318ce7ceb96f1af"}[chunkId] + ".js";
};